import { render } from "./BaseFilterModal.vue?vue&type=template&id=1d5d39c9"
import script from "./BaseFilterModal.vue?vue&type=script&lang=js"
export * from "./BaseFilterModal.vue?vue&type=script&lang=js"
script.render = render

export default script